import React, { Component } from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'connected-react-router';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Header, Dropdown, Button } from 'semantic-ui-react';

import * as Events from '../../store/Events';

function base64ToArrayBuffer(base64) {
  var binaryString = window.atob(base64);
  var binaryLen = binaryString.length;
  var bytes = new Uint8Array(binaryLen);
  for (var i = 0; i < binaryLen; i++) {
    var ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}
function saveByteArray(reportName, byte) {
  var blob = new Blob([byte], { type: 'application/csv' });
  var link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  var fileName = reportName;
  link.download = fileName;
  link.click();
}

class Reports extends Component {
  constructor(props) {
    super(props);

    this.state = {
      eventId: null,
      eventName: null,
    };

    this.onDropdownChange = this.onDropdownChange.bind(this);
    this.onDownloadClick = this.onDownloadClick.bind(this);
    this.onDownloadSummaryClick = this.onDownloadSummaryClick.bind(this);
  }

  onDropdownChange(e, data) {
    const idx = data.options.findIndex((o) => o.value === data.value);
    const text = data.options[idx].text;
    this.setState({ eventId: data.value, eventName: text });
  }

  async onDownloadClick(e) {
    const { actions } = this.props;
    try {
      const result = await actions.downloadEventReport(this.state.eventId);
      const file = base64ToArrayBuffer(result.response.report);
      saveByteArray(`${this.state.eventName}.csv`, file);
    } catch (error) {
      console.log(error);
    }
  }
  async onDownloadSummaryClick(e) {
    const { actions } = this.props;
    try {
      const result = await actions.downloadEventReport(this.state.eventId, true);
      const file = base64ToArrayBuffer(result.response.report);
      saveByteArray(`${this.state.eventName}-summary.csv`, file);
    } catch (error) {
      console.log(error);
    }
  }

  render() {
    const { event } = this.props;
    const eventOptions = Object.values(event.events).map((f, index) => ({ text: f.name, value: f.id }));
    return (
      <div>
        <Header as="h1" content="Reports" />
        <Header as="h2" content="Reservations" />
        <Dropdown selection placeholder="Choose an Event" options={eventOptions} onChange={this.onDropdownChange} />{' '}
        <Button content="Download Detail" disabled={!this.state.eventId} onClick={this.onDownloadClick} />
        <Button content="Download Summary" disabled={!this.state.eventId} onClick={this.onDownloadSummaryClick} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    event: Events.selector(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: {
    ...bindActionCreators(Events.actionCreators, dispatch),
    ...bindActionCreators(routerActions, dispatch),
  },
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Reports),
);
